import { isAdminToken } from "./sessionToken";

const STORAGE_KEY = "vc.sessionToken";

export function rememberSessionToken(token: string): string {
  if (!token) return "";
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage can be unavailable in hardened embedded browsers; keep using the token in memory.
  }
  return token;
}

function readStoredToken(): string {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

export function readSessionToken(search?: URLSearchParams): string {
  const fromUrl = search?.get("token") ?? "";
  if (fromUrl) return rememberSessionToken(fromUrl);
  return readStoredToken();
}

/**
 * Return an ADMIN-authorized session token (payload roles include Administrator/ITViewer), or
 * "" when none is available. A URL admin token is persisted, replacing any stale non-admin
 * (traffic/field) token from a prior /demo/traffic or /demo/field visit. A stored non-admin
 * token is never returned, so /admin never sends a token the server will only 403.
 *
 * The role check is decoded from the untrusted payload purely to pick the right token (UX);
 * the server stays authoritative on every admin endpoint.
 */
export function readAdminToken(search?: URLSearchParams): string {
  const fromUrl = search?.get("token") ?? "";
  if (fromUrl && isAdminToken(fromUrl)) return rememberSessionToken(fromUrl);

  const stored = readStoredToken();
  return isAdminToken(stored) ? stored : "";
}
